import React from 'react'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { cnWeChatPopOver } from '../../../../utils/cn.utils'
import {
  Facebook_Logo,
  Instagram_logo,
  Linkedin_Logo,
  Security_Logo,
  Slack_Logo,
  Toutiao_Logo,
  Twitter_Logo,
  Wechat_Logo,
  Weibo_Logo,
  Youku_Logo,
  Youtube_Logo,
} from '../../newFooter/utils/footerLogos'

const LINKEDIN = 'linkedin'
const FACEBOOK = 'facebook'
const TWITTER = 'twitter'
const YOUTUBE = 'youtube'
const INSTAGRAM = 'instagram'
const WEIBO = 'weibo'
const TOUTIAO = 'toutiao'
const YOUKU = 'youku'

const RIGHTS_RESERVED = 'rights.reserved.footer.text'
const COOKIE_SETTING = 'cookie.setting.text'
const ICP_NUMBER = 'icp.number.text'
const SECURITY_NUMBER = 'security.number.text'
const ICP_NUMBER_LINK = 'icp.number.link'
const SECURITY_NUMBER_LINK = 'security.number.link'
const COOKIE_SETTINGS_LINK = 'cookie-settings-link'
const DISCLAIMER_FOOTER_TEXT = 'logo.disclaimer.footer.text'

export const SocialMediaIcons = ({ socialUrls, navEntryLocale }: any) => {
  let socialData: any = {}
  socialUrls?.forEach((social: any) => {
    if (social.key.startsWith(LINKEDIN)) socialData.LINKEDIN = social.value
    else if (social.key.startsWith(FACEBOOK)) socialData.FACEBOOK = social.value
    else if (social.key.startsWith(TWITTER)) socialData.TWITTER = social.value
    else if (social.key.startsWith(YOUTUBE)) socialData.YOUTUBE = social.value
    else if (social.key.startsWith(INSTAGRAM)) socialData.INSTAGRAM = social.value
    else if (social.key.startsWith(WEIBO)) socialData.WEIBO = social.value
    else if (social.key.startsWith(TOUTIAO)) socialData.TOUTIAO = social.value
    else if (social.key.startsWith(YOUKU)) socialData.YOUKU = social.value
  })
  return navEntryLocale !== LocaleCodes.CHINESE.code ? (
    socialUrls
      .filter((social: any) => social.key !== DISCLAIMER_FOOTER_TEXT)
      .map((social: any) => {
        const socialName = social.key.split('.')[0]

        if (
          socialName === 'rss' ||
          socialName === 'socials' ||
          socialName === 'rights' ||
          socialName === 'cookie'
        )
          return '' // ignore RSS feed and other strings
        return (
          <a
            href={social.value ? social.value : '/'}
            target="_blank"
            rel="noopener"
            key={`social-item--${socialName}`}>
            {socialName === 'linkedin' && Linkedin_Logo}
            {socialName === 'facebook' && Facebook_Logo}
            {socialName === 'twitter' && Twitter_Logo}
            {socialName === 'youtube' && Youtube_Logo}
            {socialName === 'slack' && Slack_Logo}
            {socialName === 'instagram' && Instagram_logo}
          </a>
        )
      })
  ) : (
    <>
      <a href="javascript:void(0)" onClick={cnWeChatPopOver} data-target="popover_wechat">
        {Wechat_Logo}
      </a>
      {socialData.WEIBO ? (
        <a href={socialData.WEIBO} target="_blank">
          {Weibo_Logo}
        </a>
      ) : null}

      {socialData.TOUTIAO ? (
        <a href={socialData.TOUTIAO} target="_blank">
          {Toutiao_Logo}
        </a>
      ) : null}

      {socialData.LINKEDIN ? (
        <a href={socialData.LINKEDIN} target="_blank">
          {Linkedin_Logo}
        </a>
      ) : null}

      {socialData.YOUKU ? (
        <a href={socialData.YOUKU} target="_blank">
          {Youku_Logo}
        </a>
      ) : null}
    </>
  )
}

export const CopyRightLinks = ({ footerData, navEntryLocale }: any) => {
  const firstNode = footerData?.allContentfulNavMenu?.nodes?.[0] || {}
  const socialMicrocopySet = firstNode?.socialMediaFooterOnly?.[0]?.values || []

  let socialData: any = {}
  socialMicrocopySet?.forEach((social: any) => {
    if (social.key === RIGHTS_RESERVED) socialData.RIGHTS_RESERVED = social.value
    else if (social.key === COOKIE_SETTING) socialData.COOKIE_SETTING = social.value
    else if (social.key === ICP_NUMBER) socialData.ICP_NUMBER = social.value
    else if (social.key === SECURITY_NUMBER) socialData.SECURITY_NUMBER = social.value
    else if (social.key === ICP_NUMBER_LINK) socialData.ICP_NUMBER_LINK = social.value
    else if (social.key === SECURITY_NUMBER_LINK) socialData.SECURITY_NUMBER_LINK = social.value
    else if (social.key === COOKIE_SETTINGS_LINK) socialData.COOKIE_SETTINGS_LINK = social.value
  })

  const year = new Date().getFullYear()
  return (
    <>
      {navEntryLocale === LocaleCodes.CHINESE.code ? (
        <>
          <a
            href={socialData.ICP_NUMBER_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="nohover">
            {socialData.ICP_NUMBER}
          </a>

          <a href={socialData.SECURITY_NUMBER_LINK} target="_blank" className="nohover">
            {Security_Logo}
            {socialData.SECURITY_NUMBER}
          </a>
        </>
      ) : null}

      <span>{`© 2005-${year} ${
        navEntryLocale !== (LocaleCodes.JAPANESE.code || LocaleCodes.SPANISH.code)
          ? socialData.RIGHTS_RESERVED
          : `UiPath. All rights reserved.`
      }`}</span>
    </>
  )
}

export const DisclaimerText = ({ footerData }: any) => {
  const firstNode = footerData?.allContentfulNavMenu?.nodes?.[0]
  const socialMicrocopySet = firstNode?.socialMediaFooterOnly?.[0]?.values

  let socialData: any = {}
  socialMicrocopySet?.forEach((social: any) => {
    if (social.key === DISCLAIMER_FOOTER_TEXT) socialData.DISCLAIMER_FOOTER_TEXT = social.value
  })
  
  return <p>{socialData.DISCLAIMER_FOOTER_TEXT}</p>
}
